import { LoadedInfo, PreviewPaneMode, WacPreviewState } from 'owa-sxsdata';
import getOrCreateSxSStoreData from '../store/Store';
import { LoadOrErrorEventData, PreviewLoadOrErrorEvent } from '../utils/eventNames';

export default async function waitForPreviewLoadOrThrowError(
    sxsId: string
): Promise<null | LoadedInfo> {
    const store = getOrCreateSxSStoreData(sxsId);

    if (
        store.extendedViewState.isCloudy &&
        store.viewState.previewPane &&
        store.viewState.previewPane.mode === PreviewPaneMode.Wac &&
        !(store.viewState.previewPane as WacPreviewState).jsApiInfo
    ) {
        // dont' wait for event for cloudy WAC document if JsApi is not enabled
        // post message is not working yet and there won't be a load event
        return null;
    } else {
        // wait for load/error event
        let errorMessage: string = null;
        let error: Error = null;
        let loadedInfo: null | LoadedInfo = null;
        await new Promise<void>(resolve => {
            store.eventManager.once(PreviewLoadOrErrorEvent, (data: LoadOrErrorEventData) => {
                errorMessage = data.errorMessage;
                error = data.error;
                loadedInfo = data.loadedInfo;
                resolve();
            });
        });

        if (error) {
            throw error;
        }

        if (errorMessage) {
            throw new Error(errorMessage);
        }

        return loadedInfo;
    }
}
